import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/dropzone/styles.layer.css';
import 'mantine-datatable/styles.layer.css';

import { MantineProvider } from '@mantine/core';
import { AreaErrorBoundary, cssResolver, theme } from '@scoring/ui';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Router } from './Router';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export default function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <MantineProvider
                theme={theme}
                cssVariablesResolver={cssResolver}
                withCssVariables
                defaultColorScheme="auto"
            >
                <AreaErrorBoundary area="app">
                    <Router />
                </AreaErrorBoundary>
            </MantineProvider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}
